import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Tabs from 'tbk-components/src/components/Tabs';
import Tab from 'tbk-components/src/components/Tab';

export interface IDonation {
	image?: IImage;
	label?: string;
}

export interface IDonationsWeAcceptProps extends IBaseElementProps {
	acceptedLabel?: string;
	acceptedDonations?: IDonation[];
	unacceptedLabel?: string;
	unacceptedDonations?: IDonation[];
}

/**
 * Donations We Accept
 * @block
 * @requiresHooks
 * @icon editor-insertmore
 */
const DonationsWeAccept: React.FC<IDonationsWeAcceptProps> = ({
	className,
	classNames = [],
	acceptedLabel = 'Donations We Accept',
	acceptedDonations = [],
	unacceptedLabel = "What We Don't Accept",
	unacceptedDonations = [],
}) => {
	const tabsData: [string, IDonation[]][] = [
		[acceptedLabel, acceptedDonations],
		[unacceptedLabel, unacceptedDonations],
	];
	return (
		<div className={className || cn('donations-we-accept', ...classNames)}>
			<Tabs>
				{tabsData.map(([label, donations], index) => (
					<Tab key={index} title={label}>
						<div className="donations-we-accept__tab">
							{Array.isArray(donations) &&
								donations.map(
									({ image, label: itemLabel }, dIndex) => (
										<div
											key={dIndex}
											className="donations-we-accept__tab__item"
										>
											<Image
												{...image}
												className="donations-we-accept__tab__item__image"
											/>
											<div className="donations-we-accept__tab__item__label">
												{itemLabel}
											</div>
										</div>
									),
								)}
						</div>
					</Tab>
				))}
			</Tabs>
		</div>
	);
};

export default DonationsWeAccept;
